//Number of seconds from the end of the previous table to this table (starting when they are read)
export const tableTimes = [
  165, 27.5, 15.4, 15.4, 7.4, 14.6, 17.9, 29.8, 26.9, 32.4, 16.5, 14.9, 15,
  15.4, 18.1, 19.8, 16.4, 43.9, 28.1, 23.9, 24, 25.8, 28.8, 26, 18.5, 16.1,
];
